import type { EditorTreeSelection } from '@/features/studio/components/ScriptEditorTree'

export function scrollEditorToTreeSelection(root: HTMLElement | null, sel: EditorTreeSelection) {
  if (!root) return
  let el: Element | null = null
  if (sel.kind === 'scene') {
    el = root.querySelector(`[data-scroll-marker="scene:${sel.episodeNo}:${sel.sceneNo}"]`)
  } else if (sel.kind === 'episode') {
    el = root.querySelector(`[data-scroll-marker="episode:${sel.episodeNo}"]`)
  } else if (sel.kind === 'season') {
    el = root.querySelector(`[data-scroll-marker="season:${sel.seasonNo}"]`)
  } else if (sel.kind === 'story') {
    el = root.querySelector('[data-scroll-marker^="episode:"]')
  }
  if (el) {
    el.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }
}
